module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('h1', {
    staticClass: "chp",
    attrs: {
      "id": "_idParaDest-5"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor004"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "epi"
  }, [_c('i', {
    staticClass: "italic"
  }, [_vm._v("The mind of man is capable of anything—because everything is in it, all the past as well as all the future.")])]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("—Joseph Conrad, "), _c('i', {
    staticClass: "italic"
  }, [_vm._v("Heart of Darkness")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ef31c402","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Headhunter-5.vue
// module id = 78
// module chunks = 0